module.exports = __webpack_public_path__ + "media/images/favicon-6022523dfbb886ee0ff36a844d1cbb31.png";